import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    update: false
  },
  reducers: {
    setNotificationUpdate: (state, action) => {
      state.update = action.payload;
    }
  }
});

export const { setNotificationUpdate } = notificationSlice.actions;
export default notificationSlice.reducer;
